import { ATC_DATA } from '../types';
import RegimeSummary from './regime-summary';
interface ATC_TAX_SUMMARY_PROPS {
  newRegimeResults: ATC_DATA;
  oldRegimeResults: ATC_DATA;
  oldRegimeTaxDue: string;
  newRegimeTaxDue: string;
}

const AtcTaxSummary: React.FC<ATC_TAX_SUMMARY_PROPS> = ({
  newRegimeResults,
  oldRegimeResults,
  oldRegimeTaxDue,
  newRegimeTaxDue,
}) => {
  return (
    <>
      <div className="mx-auto w-full relative p-12 sm:p-5">
        <div className="text-s-48 font-bold  text-font-500  sm:text-s-24">
          Summary
        </div>
        <div className="font-bold text-s-24 my-6">New regime</div>
        <RegimeSummary
          regime={newRegimeResults}
          totalAdvanceTaxDue={newRegimeTaxDue}
        />
        <div className="font-bold text-s-24 my-6">Old regime</div>
        <RegimeSummary
          regime={oldRegimeResults}
          totalAdvanceTaxDue={oldRegimeTaxDue}
        />
      </div>
    </>
  );
};

export default AtcTaxSummary;
